import { Button, TextInput } from 'components/Form'
import { HiOutlineUser } from 'react-icons/hi'
import { Link, useNavigate } from 'react-router-dom'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { apiForgotPassword } from 'services/AuthService'

const validationSchema = Yup.object().shape({
    email: Yup.string().required('email is required'),
})

export default function ForgotPassword() {
    const navigate = useNavigate()

    const onSignIn = async (values, setSubmitting) => {
        setSubmitting(true)
        apiForgotPassword(values)
            .then(() => {
                Success('Send reset password link successfully!')
                navigate('/login')
            })
            .catch((error) => error)
        setSubmitting(false)
    }

    return (
        <>
            <span className="flex justify-center">
                <img
                    className="w-[40%] h-[40%]"
                    src="/images/logo.png"
                    alt="error"
                />
            </span>
            <Formik
                initialValues={{
                    email: '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                    onSignIn(values, setSubmitting)
                }}
            >
                {({ touched, errors, isSubmitting }) => (
                    <Form className="flex flex-col gap-4">
                        <Field name="email">
                            {({ field, form }) => (
                                <TextInput
                                    type="text"
                                    id="email"
                                    name="email"
                                    className="font-medium"
                                    placeholder={'Enter email address here'}
                                    autoComplete="email"
                                    isFocused={true}
                                    icon={<HiOutlineUser />}
                                    error={errors.email && touched.email}
                                    message={errors.email}
                                    onChange={(e) =>
                                        form.setFieldValue(
                                            field.name,
                                            e.target.value,
                                        )
                                    }
                                />
                            )}
                        </Field>
                        <p>{'Enter your email address to find your account'}</p>
                        <Button
                            className="w-full mt-3 text-white font-semibold border-primary bg-primary dark:border-secondary dark:bg-secondary"
                            disabled={isSubmitting}
                            type="submit"
                        >
                            Send Email
                        </Button>
                        <div className="text-center">
                            <p className="font-medium">
                                <Link to="/login">Login</Link>
                            </p>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}
